<div>

    <div class="modal-body address-popup-body">
        <form #form="ngForm" autocomplete="off">
            <div class="form-group">
                <div class="margin-b">
                    <input class="input" type="text" [(ngModel)]="autocompleteInput"
                        [ngModelOptions]="{standalone: true}" #addresstext class="form-control"
                        placeholder="Name of the Location">


                 
                </div>

                <div class="row margin-b">
                    <div class="col-md-12 ">

                        <div class="display justify-content">
                            <div>
                                Limit results to current region
                            </div>

                            <div>

                                <div class="switch_box box_1">
                                    <input type="checkbox" class="switch_1" checked (click)="limitCheckbox($event)">
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                <div class="row margin-b">
                    <div class="col-md-6 margin-b">
                        <input class="form-control" type="text" [(ngModel)]="addr.streetAddress"
                            name="streetAddress"  placeholder="Street Address">
                    </div>

                    <div class="col-md-6">
                        <input class="form-control" type="text" [(ngModel)]="addr.suite_no"
                           name="suite_no" placeholder="Suite No ">
                    </div>
                </div>
                <div class="row margin-b">
                    <div class="col-md-6 margin-b">
                        <input class="form-control" type="text" [(ngModel)]="addr.city"
                           name="city" placeholder="city">
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text" [(ngModel)]="addr.state"
                           name="state" placeholder="State">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 margin-b">
                        <input class="form-control" type="text" name="postalCode" [(ngModel)]="addr.postalCode"
                            placeholder="Postal Code">
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" type="text" [(ngModel)]="addr.country" name="country"
                             placeholder="country">
                    </div>
                </div>
                <div class="form-group" style="text-align: end;"> 
<button class="btn  main-backgroundcolor color" (click)="invokeEvent()">Add</button>

                </div>
       
                <br>
            </div>
        </form>
    </div>

</div>